if (!customElements.get('header-search-99')) {
  customElements.define(
    'header-search-99',
    class HeaderSearch99 extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('.header-99__search-toggle');
        this.drawer = this.querySelector('.header-99__search-drawer');
        this.closeButton = this.querySelector('.header-99__search-close');
        this.field = this.querySelector('.header-99__search-field');
        this.input = this.querySelector('.header-99__search-input');
        this.isOpen = false;

        this.toggleButton.addEventListener('click', () => this.toggle());
        this.closeButton.addEventListener('click', () => this.close());

        this.input.addEventListener('input', () => {
          this.field.classList.toggle('has-value', this.input.value.trim().length > 0);
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.isOpen) this.close();
        });

        document.addEventListener('click', (event) => {
          if (this.isOpen && !this.contains(event.target)) this.close();
        });

        window.addEventListener('resize', () => {
          if (this.isOpen) this.position();
        });

        this.drawer.addEventListener('transitionend', () => {
          if (!this.isOpen) this.drawer.hidden = true;
        });
      }

      position() {
        const announcementBar = document.querySelector('.utility-bar');
        const header = document.querySelector('.header-99');
        const announcementHeight = announcementBar ? announcementBar.getBoundingClientRect().height : 0;
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        this.drawer.style.top = `${announcementHeight + headerHeight}px`;
      }

      toggle() {
        this.isOpen ? this.close() : this.open();
      }

      open() {
        this.position();
        this.drawer.hidden = false;
        this.toggleButton.setAttribute('aria-expanded', 'true');
        this.isOpen = true;

        requestAnimationFrame(() => {
          this.drawer.classList.add('is-open');
        });

        window.setTimeout(() => this.input.focus(), 200);
      }

      close() {
        this.drawer.classList.remove('is-open');
        this.toggleButton.setAttribute('aria-expanded', 'false');
        this.isOpen = false;
      }
    }
  );
}